/**
 * This file extends javascript window object with some utility functions.
 */

export type LocationChangeEventProps = {
  type: 'pushstate' | 'replacestate' | 'popstate';
};

// history change
window.history.pushState = ((f) =>
  function pushState() {
    // @ts-ignore
    // biome-ignore lint/style/noArguments: <explanation>
    const ret = f.apply(this, arguments);
    window.dispatchEvent(new Event('pushstate'));
    window.dispatchEvent(
      new CustomEvent<LocationChangeEventProps>('locationchange', {
        detail: { type: 'pushstate' },
      })
    );
    return ret;
  })(window.history.pushState);

window.history.replaceState = ((f) =>
  function replaceState() {
    // @ts-ignore
    // biome-ignore lint/style/noArguments: <explanation>
    const ret = f.apply(this, arguments);
    window.dispatchEvent(new Event('replacestate'));
    window.dispatchEvent(
      new CustomEvent<LocationChangeEventProps>('locationchange', {
        detail: { type: 'replacestate' },
      })
    );
    return ret;
  })(window.history.replaceState);

window.addEventListener('popstate', () => {
  window.dispatchEvent(
    new CustomEvent<LocationChangeEventProps>('locationchange', {
      detail: { type: 'popstate' },
    })
  );
});
